import {useSelector} from "react-redux";
import {BT_DEFAULT_FILTERS, DEFAULT_FILTERS} from "../components/user/riaPowerSearch/defaultFilters";

function useUserSession() {
    const session = useSelector((state) => state.login.userSession);
    const globalSession = useSelector((state) => state.login.globalSession);

    const sectionFilters = (section, allFilters, searchValue = '', filterType = 'ria') => {
        let filters = filterType === 'ria' ? DEFAULT_FILTERS : BT_DEFAULT_FILTERS;
        let customFilters = filterType === 'ria' ? session.custom_filters : session.bt_custom_filters;

        const matchedTitle = searchValue ? filters[section].title.toLowerCase().includes(searchValue.toLowerCase()) : false;
        return allFilters ?
            (filters[section].filters || []).filter(f => matchedTitle || f.name.toLowerCase().includes(searchValue?.toLowerCase() || '')).map(f => f?.key).filter(e => e)
            : (customFilters?.[section] || [])
    }

    return {
        session,
        globalSession,
        sectionFilters,
    }
}

export default useUserSession;